import React from "react";
import axios from 'axios';
import TextField from '@material-ui/core/TextField';

import { makeStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import Container  from '@material-ui/core/Container';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import ViewIcon from '@material-ui/icons/Visibility';
   
import Typography from '@material-ui/core/Typography';

import {DropzoneArea} from 'material-ui-dropzone'

import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

import Link from '@material-ui/core/Link';

import LinearProgress from '@material-ui/core/LinearProgress';

import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';

import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
 
import FormHelperText from '@material-ui/core/FormHelperText'

import api from '../../common/api';

class SLAForm extends React.Component {

	constructor() {
		super();
		this.state = { 
			sla: {
				id:'',
				contract_id:'',
				name:'',
				description:'',
				due_date:'',
				tasks:[{task_id:'', work_order_state_id:'',unit_id:'', value:'', active:false, taskLabel:'', error:''}],
			},
			disabled: false,
			dialogOpen: false,
			loading: true,
			action: '',
			tasks_data: [],
			states_data:[],
			files:[],
			loading: true,
			media:[],
		}
	
	}

	async componentDidMount() {
		await this.getStates();
		await this.getTasks();	
		await this.getParams();
	}

	handleChangeForm = (e) => {
		var res = e.target.id.split("-");
	  	const varName =res[0];
	  	const id =res[1];
 		let slaCopy = JSON.parse(JSON.stringify(this.state.sla))
 		if (['value','task_id','unit_id','value', 'active','work_order_state_id'].includes(varName)){
 			if (varName==='active'){
 				slaCopy['tasks'][id]['active']=!slaCopy['tasks'][id]['active']
 			} else {
	        slaCopy['tasks'][id][varName] = e.target.value
 			}
 		slaCopy['tasks'][id]['error'] =''
 		} else {
	        slaCopy[varName]= e.target.value
 		}
        this.setState({ sla: slaCopy})
        if (slaCopy['tasks'][id]){
	        var found = parseInt(this.handleValidations(slaCopy['tasks'][id]))
	        if (found !== -1 && found !== parseInt(id)){
	        	slaCopy['tasks'][id]['error'] = 'Esta tarea ya fue cargada con el mismo estado'
	        	this.setState({sla: slaCopy})
	        }
        }
	}

	handleValidations(task){
		var sla = this.state.sla
		return sla.tasks.findIndex(el => (parseInt(el.task_id) === parseInt(task.task_id) && parseInt(el.work_order_state_id) === parseInt(task.work_order_state_id) && el.active === true))
	}

	handleRedirect(){
		window.location.href="/contracts"
	}

	handleUpload(files){
		this.setState({
		  files: files
		});
	}


	handleSubmit = (e) => {
		e.preventDefault()

		var formData = new FormData();
		formData.set('service_agreement[contract_id]', this.state.contract_id)
		formData.set('service_agreement[name]', this.state.sla.name)
		formData.set('service_agreement[description]', this.state.sla.description)
		formData.set('service_agreement[description]', this.state.sla.description)
		formData.set('service_agreement[due_date]', this.state.sla.due_date)

		var i = 0;
		var hasErrors = false;
		this.state.sla.tasks.map((val, idx) => {
			if (val.error !=''){
				hasErrors = true
			}

			if (this.state.action === 'edit' && val.id != null){
				formData.set('service_agreement[tasks]['+i+'][id]', val.id)
			}
			var active = 0

			if (val.active === true || val.active===1){
				active = 1
			} 
			if (val.task_id){
				formData.set('service_agreement[tasks]['+i+'][task_id]', val.task_id)
				formData.set('service_agreement[tasks]['+i+'][unit_id]', val.unit_id)
				formData.set('service_agreement[tasks]['+i+'][value]', val.value)
				formData.set('service_agreement[tasks]['+i+'][task_state_id]',1)
				formData.set('service_agreement[tasks]['+i+'][active]',active)
				formData.set('service_agreement[tasks]['+i+'][work_order_state_id]', val.work_order_state_id)
				i++;
			}
		})

		if (hasErrors){
			this.setState({message: 'Hay errores en la carga. Por favor validar'})
			this.setState({dialogOpen: true})
			this.setState({errors: true})
			return 
		}

		if (i==0){
			formData.set('service_agreement[tasks]',[]);
		}	

		this.state.files.map((val, idx) => {
			formData.append(`media[${idx}]`, val)
		})
		
		var self = this
		const token =localStorage.getItem('userToken')

		if (this.state.action === 'new'){
		    axios.post(api.sla().post(this.state.contract_id),
		       formData,
			   {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}` }}
		       )
		      .then((response)=> {
	                self.setState({errors: false})
		            self.setState({message: 'SLA creado con éxito!'})
	    	        self.setState({dialogOpen: true})
		      })
		      .catch(function (error) {
	                self.setState({errors: true})
		            self.setState({message: 'Hubo algun problema al crear el SLA. Por favor volver a intentar'})
	    	        self.setState({dialogOpen: true})
		    })
		} else {

			formData.append('service_agreement[id]',this.state.sla.id)
			formData.append('_method','patch')
		    axios.post(api.sla().patch(this.state.sla.id),
		       formData,
			   {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}` }}
		       )
		      .then((response)=> {
	                self.setState({errors: false})
		            self.setState({message: 'SLA modificado con éxito!'})
	    	        self.setState({dialogOpen: true})
		      })
		      .catch(function (error) {
	                self.setState({errors: true})
		            self.setState({message: 'Hubo algun problema al crear el SLA. Por favor volver a intentar'})
	    	        self.setState({dialogOpen: true})
		    })
		}
	  e.preventDefault()

	}
	
	async getParams(location) {
	    const searchParams = new URLSearchParams(window.location.search);
    	const contract_id = searchParams.get('id')
    	this.setState({contract_id: contract_id})
		var id = await this.getSLAByContract(contract_id)
    	var action =this.state.action
    	if (action === 'new'){
    		this.setState({action: action})
    		this.setState({disabled: false})
      	} else if (action === 'view') {
      		await this.setSLA(id)
    		this.setState({action: action})
    		this.setState({disabled: true})
    		//this.setSLA(contract_id);
    	}
		
		this.setState({loading: false})

    }

	getStates(){
		const token =localStorage.getItem('userToken')

		return axios
		     .get(api.workOrderStates,{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		          res.data = Object.values(res.data);
		          this.setState({states_data: res.data})
		      })
		      .catch(err =>{console.log(err)
		      })		
	}

	async getSLAByContract(contract_id) {
		const token =localStorage.getItem('userToken')

		  return await axios
		     .get(api.contract().get(contract_id),{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		      	  this.setState({action: 'view'})
		          return res.data[0].service_agreement.id
		      })
		      .catch(err =>{
		      	  this.setState({action: 'new'})
		      })
	}

	async getSLA(id){
		const token =localStorage.getItem('userToken')

      	return await axios
		     .get(api.sla().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		          return res.data
		      })
		      .catch(err =>{
		      	console.log('error!', err)
		      })

	}
	
	getTasks= () => {
		const token =localStorage.getItem('userToken')

	    return axios
	         .get(api.tasks,{ headers: {"Authorization" : `Bearer ${token}`} })
	          .then(res => {
	              res.data = Object.values(res.data);
	              this.setState({tasks_data: res.data})
	              return res.data
	          })
	          .catch(err =>{console.log(err)
	          })
	  }


	async setSLA(idSLA){
		 var slaCopy = {}
		 var media = []
		 var tasks = []
		 const result = await this.getSLA(idSLA).then(result =>
		      {
		        var promise = new Promise(function(resolve, reject) {
		          resolve(result);
		          slaCopy.name = result.name
		          slaCopy.due_date = result.due_date
				  media = result.media
		          slaCopy.description = (result.description ===null || result.description ==='')  ? '': result.description
				  let sla_tasks = result.tasks
		          sla_tasks.map((val, idx) => {
		          		tasks.push({id: val.id, task_id: val.id, work_order_state_id: val.work_order_state.id, unit_id: val.task.unit.id, value: val.value, active:val.active, taskLabel: val.task.task.name, error:''}) 
				  })
				  //slaCopy.tasks = [{task_id:result.tasks.id, work_order_state_id:'',unit_id:'', value:'', active:false, taskLabel:''}]
		  })
	    })
		 slaCopy.tasks = (tasks.length > 0 ) ? tasks : [{task_id:'', work_order_state_id:'',unit_id:'', value:'', active:false, taskLabel:'', error:''}]
		 slaCopy.id = idSLA
		 slaCopy.due_date = this.formatDate(slaCopy.due_date)
		 this.setState({sla: slaCopy})
		 this.setState({media: media})
	}
	
	formatDate(date){
		
		if (date ==='' || date ===null || date==='null'){
			return null;
		}
		//hansa_start_date = '2019-12-31'
		    	//return newDate[2]
		let fromDate = new Date(date)
		let year = fromDate.getFullYear();
		
		let month = fromDate.getMonth() + 1
		month = month < 10 ? '0'+month: month
		let day =  fromDate.getDate() < 10 ? '0'+ fromDate.getDate(): fromDate.getDate()
		//return fromDate.getFullYear() + "-" + (fromDate.getMonth()+1) + "-" + fromDate.getDate();

		return year+'-'+month+'-'+day
	}


	useStyles(){
		makeStyles({
			  table: {
			    minWidth: 650,
			  },
			});	
	} 

	addNewItem = (e) => {
		let slaCopy = this.state.sla;
		slaCopy.tasks.push({task_id:'', unit_id: '', work_order_state_id:'', value:'', active:'', error:''})
		this.setState({sla: slaCopy})
	}

	removeItem = idx => () => {
	    this.setState((prevState) => ({
	      sla: { ...prevState.sla, 
	      		tasks: [...prevState.sla.tasks.filter((s, sidx) => idx !== sidx)]
	    	  },
	    }));
	}
	
	setDropdownTask(idx,e){
	    var res = idx.split("-");
	    const varName =res[0];
	    const id =res[1];

		let slaCopy = this.state.sla
		slaCopy.tasks[id]['task_id'] = e.value
		slaCopy.tasks[id]['taskLabel'] = e.label
		this.setState({ sla: slaCopy })

	}

	handleEdit(){
		this.setState({action: 'edit'})
		this.setState({disabled: false})
	}

	handleView(){
		this.setState({action: 'view'})
		this.setState({disabled: true})
	}


	render (){
		const onChange = (currentNode, selectedNodes) => {
			console.log('onChange::', currentNode, selectedNodes)
		}
		const onAction = (node, action) => {
			console.log('onAction::', action, node)
		}
		const onNodeToggle = currentNode => {
			console.log('onNodeToggle::', currentNode)
		}
		
		const handleRedirect = id => () =>{
			window.location.href=`/contracts`
		}

		const handleDialogClose = () => {
			this.setState({dialogOpen: false})
		}		
		const classes = this.useStyles();
		let sla = this.state.sla
		let data = this.state.tasks_data
		let sla_states = this.state.states_data
		let media = this.state.media
		return(
			 (this.state.loading)?
               <LinearProgress /> 
            :
            <form onSubmit={this.handleSubmit} onChange={this.handleChangeForm} >
			<Dialog
				open={this.state.dialogOpen}
				fullWidth
				aria-labelledby="responsive-dialog-title"
			>
            <DialogTitle id="responsive-dialog-title">{"SLA"}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                  {this.state.message}
              </DialogContentText>
            </DialogContent>
            <DialogActions disableSpacing="false">  
              {(this.state.errors) ?
                <Button onClick={handleDialogClose} variant="contained" color="primary" >
                    Aceptar
                </Button>
                :
                <Button onClick={handleRedirect(this.state.contract_id)} variant="contained" color="primary" >
                    Aceptar
                </Button>
               }
            </DialogActions>
          </Dialog>
	  		<div class="col-12 m-0 p-0">
				<div class="row">
					<div class="col-9">
						<TextField
					          disabled={this.state.disabled}
							  id="name"
							  placeholder="Ingrese un nombre de SLA"
							  label="Nombre del SLA"
							  required
							  className="m-2"
							  name="name"
							  value={sla.name}
							  InputLabelProps={{
							    shrink: true
							  }}
							  inputProps={{style:{fontSize: '0.75rem'}}} 
							/>
							<TextField
					          disabled={this.state.disabled}
					          required
							  id="due_date"
							  placeholder="Ingrese la fecha de vencimiento"
							  label="Fecha de vencimiento"
							  required
							  className="m-2"
							  type="date"
							  name="due_date"
							  value={sla.due_date}
							  InputLabelProps={{
							    shrink: true
							  }}
							  inputProps={{style:{fontSize: '0.75rem'}}} 
							/>
					</div>
					<div class="col-3">
	      				{(this.state.action ==='view')?(
						<div style={{textAlign: "right"}}>
							<Fab color="secondary" aria-label="edit" className='MuiButtonBase-root MuiFab-sizeSmall m-1' onClick={this.handleEdit.bind(this)}>
							  <EditIcon onClick={this.handleEdit.bind(this)}  />
							</Fab>
						</div>
						):''}
						{(this.state.action==='edit')?(
						<div style={{textAlign: "right"}}>
								<Fab color="primary" aria-label="edit" className='MuiButtonBase-root MuiFab-sizeSmall m-1' onClick={this.handleView.bind(this)}>
							  <ViewIcon onClick={this.handleView.bind(this)}  />
							</Fab>
						</div>
						):''}

					</div>
				</div>
			</div>
			  <Table className="mt-2" aria-label="simple table">
			    <TableHead>
			      <TableRow>
			        <TableCell align="left" className="p-0">Grupo de tareas</TableCell>
			        <TableCell align="left" className="p-0">Fecha a medir</TableCell>
			        <TableCell align="left" className="p-0">Plazo</TableCell>
			        <TableCell align="left" className="p-0">Activo</TableCell>
			        <TableCell align="left" className="p-0"></TableCell>
			      </TableRow>
			    </TableHead>
			    <TableBody>
			      {sla.tasks.map((val, idx) => (
			        <TableRow>
			          <TableCell align="left" className="p-0">
	  					{sla.tasks[idx].task_id ==='' ? (

			          <Typography variant="caption">
      		            <DropdownTreeSelect 
                            disabled={this.state.disabled}
                            data={data} onChange={e => {onChange(e);this.setDropdownTask('tasks-'+idx,e)}}
                            onAction={onAction} onNodeToggle={onNodeToggle}
                            mode="radioSelect"
                            className="mt-2"
                            required
                            id={'task_id-'+idx}
                            texts={{ placeholder: 'Buscar tareas' }}                                 
                        />
                      </Typography>
                      ):''}
			            {sla.tasks[idx].task_id !=='' ? (
				            <TextField id={sla.tasks[idx].task_id} disabled margin="normal" className="mt-4" value={sla.tasks[idx].taskLabel} InputProps={{style: {width: '10rem', fontSize: '0.75rem'}}} />
			            ):''}
					  </TableCell>
			          <TableCell align="left" className="p-0">
						<FormControl className="mt-3 " style={{minWidth: 150, fontSize: '0.75rem'}} name='work_order_state_id' error={(sla.tasks[idx].error !== '')?true:false}>
						  <Select native name='work_order_state_id'
						  id={'work_order_state_id-'+idx}
				          disabled={this.state.disabled}
				          required
						   inputProps={{
						        name:"work_order_state_id",
						        className:"work_order_state_id"
						      }}
						      style={{minWidth: 150, fontSize: '0.75rem'}}
						      value={sla.tasks[idx].work_order_state_id}

						    input={<Input id="grouped-native-select" name='work_order_state_id'/>}>
						    <option value="" />
								{this.state.states_data.map((state) => <option id={state.id} value={state.id}>{state.name}
							</option>)}
						  </Select>
						  <FormHelperText>{sla.tasks[idx].error}</FormHelperText>						  
						</FormControl>
					  </TableCell>
			          <TableCell align="left" className="p-0">
    	 				<FormControl className="mr-2 p-0" style={{minWidth: 100, fontSize: '0.75rem'}} name="unit_id" >
						  <Select native name='unit_id'
						  required
						  id={'unit_id-'+idx}
				          disabled={this.state.disabled}
						  value={sla.tasks[idx].unit_id}
						  style={{fontSize: '0.75rem'}} input={<Input id="grouped-native-select" name="unit_id"/>}>
						    <option value="" />                   
						      <option value="6">Horas</option>
						      <option value="7">Dias</option>
						  </Select>
						</FormControl>   	

						 <TextField
				          disabled={this.state.disabled}
						  type="number"
						  placeholder="Ingrese el plazo"
						  required
						  id={`value-${idx}`}
						  name={`value-${idx}`}
						  value={val.value}
 			              InputLabelProps={{
              				shrink: true,
            			  }}
						  InputProps={{style:{width: '100px',fontSize: '0.75rem'}, inputProps: { min: 0}}}
  						/>
						</TableCell>
			          <TableCell align="left" className="p-0">
					     <FormControlLabel
					        control={
					          <Checkbox
					          	id={'active-'+idx}
     		                    disabled={this.state.disabled}
					            checked={sla.tasks[idx].active}
					          />
					        }
 					      />
					</TableCell>
					<TableCell className="p-0">
						{(this.state.disabled===false)? (

							<div class="mt-4" style={{width:"min-content", display:"inline-flex"}}> 
								<IconButton size="small" 
								disabled={(sla.tasks.length ==1) ? true : false}>
									<RemoveIcon onClick={this.removeItem(idx)} />
								</IconButton>
								<IconButton size="small"  >
									<AddIcon onClick={this.addNewItem}/>
								</IconButton>
							</div>
						):''}

				</TableCell>
			        </TableRow>
			      ))}
			    </TableBody>
			  </Table>
			<TextField
			  id="description"
			  disabled={this.state.disabled}
			  placeholder="Ingrese observaciones"
			  fullWidth
			  value={this.state.sla.description}
			  name="description"
			  margin="normal"
			  InputLabelProps={{
			    shrink: true,
			  }}
			  inputProps={{style:{fontSize: '0.75rem'}}} 

			/>  
			{(this.state.disabled===false)? (
			  <div style={{width: "30rem"}}>

			    <DropzoneArea onChange={this.handleUpload.bind(this)} 
			      dropzoneText="Arrastra los archivos aquí o buscalos"
			      showPreviews="true"
			      showPreviewsInDropzone={false}
			      showFileNamesInPreview="true"
			      showFileNames="true"
			    />
			  </div>
			):''}		

        <div className="row"></div>
        {(media.length>0)?(
        <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nombre del archivo</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {media.map((val,idx) => (
                <TableRow key={val.id}>
                  <TableCell>{val.name}</TableCell>
                  <TableCell>
                  <Link href={api.media_download+'/'+val.id}><ArrowDownwardIcon />Descargar</Link>
          </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
            ):''
          }

			  {(this.state.action !== 'view')? (
              		<div>
						<Button type="submit" variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
							Guardar
						</Button>
						<Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
							Cancelar
						</Button>
					</div>
				):
					<div>
						<Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
							Volver
						</Button>
					</div>
				}

			  </form>
		 );
	}
}

export default SLAForm;
